import { Component, OnInit, AfterViewInit, ViewChild, TemplateRef, ChangeDetectorRef, forwardRef } from "@angular/core";
import {
    CclNavbarSecondaryService,
    CclList,
    CclListColumn,
    CclTemplateResolverService,
    CclListTemplateProviderComponent,
    CclListTemplates,
    CclListColumnSize,
    CclMessageService,
    CclNavbarFooterService,
    CclDrawerService
} from "certain-common-library";
import { SharedService } from "../../../../../modules/shared/services/shared.service";
import { cloneDeep } from "lodash";
import { SessionService } from "../../../../../modules/shared/services/session-service";
import { CatalogService } from "../../../../../modules/shared/services/catalog.service";
import { Subscription } from "rxjs";
import { FlashMessagesService } from "angular2-flash-messages";
import { ActivatedRoute } from "@angular/router";
import { UnsavedChangesDeactivate } from "../../../can-deactivate";

@Component({
    selector: "app-highlighted-page",
    templateUrl: "./highlighted-page.view.html",
    styleUrls: []
})
export class HighlightedPageView extends UnsavedChangesDeactivate implements AfterViewInit, OnInit {
    @ViewChild("tempSessionList")
    tempSessionList: any;

    columns: CclListColumn[];
    subscription: Subscription;

    sessionConfigObj: any;
    sessionDataConfig: any = {};

    displayAs: any = [
        {
            label: "One Session at a time in an Automatic Carousel",
            code: "1_carousel"
        },
        {
            label: "All Sessions as List",
            code: "all_session"
        }
    ];

    displayAsHighlighted: any = [
        {
            label: "All Sessions as List",
            code: "all_session"
        }
    ];

    sessionConfig = {
        eventId: this.sharedService.event.id,
        sessionName: "",
        sessionLabel: "",
        tagIds: [],
        eventTrackIds: [],
        statusIds: [0],
        levelIds: [],
        limit: 10,
        page: 0,
        field: "[name]",
        order: "asc",
        typeIds: [],
        confResponseFilters: []
    };

    sortCase;

    sessions: CclList = <CclList>{};
    selectedSessions: CclList = <CclList>{};
    baseUrl: string;

    constructor(
        private navSecondaryService: CclNavbarSecondaryService,
        public sharedService: SharedService,
        private templateResolver: CclTemplateResolverService,
        private cdRef: ChangeDetectorRef,
        private sessionService: SessionService,
        private catalogService: CatalogService,
        private messageService: CclMessageService,
        private navbarFooterService: CclNavbarFooterService,
        private _flashMessagesService: FlashMessagesService,
        private drawerService: CclDrawerService,
        private activatedRoute: ActivatedRoute
    ) {
        super(sharedService);
        this.navSecondaryService.sectionLabel = "Data";
        if (this.activatedRoute.routeConfig.path === "highlighted") {
            this.baseUrl = "highlighted";
        } else if (this.activatedRoute.routeConfig.path === "promoted") {
            this.baseUrl = "promoted";
        }
        this.sharedService.sessionUrl = this.baseUrl;
        this.subscription = this.messageService.getMessage().subscribe((message) => this.saveSessionConfig(message));
    }

    ngOnInit() {
        this.drawerService.closeMessage = null;
        this.sessionDataConfig = cloneDeep(this.sharedService.dataConfig[this.baseUrl]);
        this.sessionConfigObj = this.sharedService.configs[this.sharedService.configTypes.DATA[this.baseUrl]];

        if (this.sessionConfigObj == null || this.sessionConfigObj.id == null) {
            this.sessionConfigObj = {
                id: null,
                sessionCatalogSetup: {
                    id: this.sharedService.setup.id
                },
                config: null,
                configType: this.sharedService.configTypes.DATA[this.baseUrl]
            };
        } else {
            this.sessionDataConfig = JSON.parse(this.sessionConfigObj.config);
        }

        if (this.sessionDataConfig.selectedList != null && this.sessionDataConfig.selectedList.length > 0) {
            this.fetchSessions();
        }

        // For checking unsaved data
        this.sharedService.originalData = cloneDeep(this.sessionDataConfig);
        this.sharedService.changedData = this.sessionDataConfig;
    }

    ngOnDestroy(): void {
        this.sharedService.unsubscribeHelper(this.subscription);
    }

    ngAfterViewInit(): void {
        const listTemplates = this.templateResolver.getTemplates(CclListTemplateProviderComponent, [
            CclListTemplates.icon,
            CclListTemplates.name,
            CclListTemplates.data,
            CclListTemplates.actionIcons
        ]);
        this.columns = [
            {
                label: "Session Name",
                template: listTemplates[CclListTemplates.name],
                size: CclListColumnSize.full,
                key: "name"
            },
            {
                label: "Session Code",
                template: listTemplates[CclListTemplates.name],
                size: CclListColumnSize.lg,
                key: "sessionCode"
            },
            {
                label: "Status",
                template: listTemplates[CclListTemplates.name],
                size: CclListColumnSize.lg,
                key: "sessionStatus"
            },
            {
                label: "Actions",
                template: listTemplates[CclListTemplates.actionIcons],
                size: CclListColumnSize.xs,
                key: "",
                templateConfig: {
                    icons: [
                        {
                            class: "fa-times action-icon-danger",
                            clickFn: this.deleteSession.bind(this),
                            title: "Delete Session"
                        }
                    ]
                }
            }
        ];

        this.cdRef.detectChanges();

        if (this.navbarFooterService.navbar != null && this.navbarFooterService.navbar.rightNavbarItems != null) {
            if (this.sharedService.sessionUrl == "highlighted") {
                this.navbarFooterService.navbar.rightNavbarItems[0].label =
                    "NEXT STEP: Define Data for promoted section";
            } else if (this.sharedService.sessionUrl == "promoted") {
                this.navbarFooterService.navbar.rightNavbarItems[0].label =
                    "NEXT STEP: Define Data for General section";
            }
            this.navbarFooterService.navbar.rightNavbarItems[1].message = "save-data-session";
            this.navbarFooterService.navbar.rightNavbarItems[2].message = "save-data-next-session";
        }
        this.messageService.sendMessage("update-publish-button");
    }

    deleteSession(e) {
        let removeIndex = this.sessionDataConfig.selectedList.indexOf(e.id);
        if (removeIndex >= 0) {
            this.sessionDataConfig.selectedList.splice(removeIndex, 1);
        }
        if (this.selectedSessions.data != null) {
            this.selectedSessions.data.forEach((element, index) => {
                if (element["id"] == e.id) {
                    this.selectedSessions.data.splice(index, 1);
                }
            });
        }
    }

    paginationFilter: any = {
        limit: 100,
        total: 0,
        count: 0,
        offset: 1
    };

    loadFilteredSessions(ev) {
        let event = cloneDeep(ev);
        this.sessionConfig.order = "asc";
        if (event.sortDescending) {
            this.sessionConfig.order = "desc";
        }
        if (event.sortProperty != null && event.sortProperty != "") {
            this.sessionConfig.field = "[" + event.sortProperty + "]";
        }

        this.fetchSessions();
    }

    fetchSessions() {
        if (this.sessionDataConfig.selectedList != null && this.sessionDataConfig.selectedList.length > 0) {
            let selectedSsessionFiler = {
                eventId: this.sharedService.event.id,
                statusIds: [0],
                limit: 10,
                page: 0,
                field: this.sessionConfig.field,
                order: this.sessionConfig.order,
                sessionIds: this.sessionDataConfig.selectedList
            };
            this.sessionService.sessionList(selectedSsessionFiler).subscribe((data) => {
                if (data.body != null) {
                    let temp = <CclList>data.body;
                    if (temp.data.length > 0) {
                        temp.data.forEach((element) => {
                            if (
                                element["publishAttendeeTypes"] != undefined &&
                                element["publishAttendeeTypes"] != null &&
                                element["publishAttendeeTypes"] != ""
                            ) {
                                element["sessionStatus"] = "Published";
                            }
                        });

                        this.selectedSessions = {data: []};

                        this.sessionDataConfig.selectedList.forEach(element => {
                            let result = temp.data.filter((obj: any) => {
                                return obj.id == element
                            })
                            if(result && result.length == 1) {
                                this.selectedSessions.data.push(result[0]);
                            }
                        });
                        this.selectedSessions.pagination = null;
                    }
                }
            });
        }
    }

    openDrawer($event) {
        $event.stopPropagation();
        this.sharedService.sessionUrl = this.baseUrl;
        this.sharedService.dataConfig[this.baseUrl] = cloneDeep(this.sessionDataConfig);
        this.drawerService.toggleDrawer("large");
        this.sharedService.currentDrawer = {
            title: "Select Another Session",
            navLinks: null,
            saveMessage: "refresh-data-session-list"
        };
        let url = "config-drawer/session/session-config";
        this.sharedService.navigateToOutlet("drawer", url);
    }

    saveSessionConfig(message) {
        if (message.text == "save-data-session" || message.text == "save-data-next-session") {
            if (this.selectedSessions.data != null) {
                if (this.selectedSessions.data.length >= 0) {
                    this.sessionDataConfig.selectedList = [];
                    this.selectedSessions.data.forEach((element) => {
                        this.sessionDataConfig.selectedList.push(element["id"]);
                    });
                }
            } else {
                this.sessionDataConfig.selectedList = [];
            }

            if (this.sessionDataConfig.selectedList.length > 10) {
                this._flashMessagesService.show(
                    "Cannot select more than 10 sessions for " + this.sharedService.toCamelCase(this.baseUrl),
                    {
                        cssClass: "alert-danger"
                    }
                );
                return false;
            }
            this.sessionConfigObj.config = JSON.stringify(this.sessionDataConfig);
            this.catalogService.saveSetupConfig(this.sessionConfigObj).subscribe((resp) => {
                // For checking unsaved data
                this.sharedService.originalData = cloneDeep(this.sessionDataConfig);
                this.sharedService.changedData = this.sessionDataConfig;

                this.sessionConfigObj = resp.body["sessionCatalogSetupConfigDTO"];
                this.sharedService.configs[this.sharedService.configTypes.DATA[this.baseUrl]] = this.sessionConfigObj;
                this._flashMessagesService.show(
                    this.sharedService.toCamelCase(this.baseUrl) + " Data saved successfully.",
                    {
                        cssClass: "alert-success"
                    }
                );
                if (message.text == "save-data-next-session") {
                    this.sharedService.currentLayoutSection = "";
                    if (this.sharedService.sessionUrl == "highlighted") {
                        this.sharedService.catalogNavigateHelper("admin", "catalog/data/promoted");
                    } else if (this.sharedService.sessionUrl == "promoted") {
                        this.sharedService.catalogNavigateHelper("admin", "catalog/data/general");
                    }
                }
            });
        }
        if (message.text === "refresh-data-session-list") {
            this.sessionDataConfig = cloneDeep(this.sharedService.dataConfig[this.baseUrl]);
            this.sharedService.changedData = this.sessionDataConfig;
            this.drawerService.hideDrawer();
            this.fetchSessions();
        }
    }
}
